import React from 'react';
import INFINITE_SCROLL_CONFIG from '../../../config/infiniteScrollConfig';

const ResultsIndicator = ({ 
  ventasCount, 
  totalVentas, 
  currentPage, 
  hasMore, 
  fechaInicio, 
  fechaFin 
}) => {
  if (totalVentas === 0) return null;

  return (
    <div className="bg-white rounded-xl shadow-lg p-4 mb-6 border border-gray-100">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="bg-gradient-to-r from-blue-500 to-indigo-500 p-2 rounded-lg">
            <span className="text-white text-lg">📊</span>
          </div>
          <div>
            <p className="text-gray-600 text-sm">
              Mostrando <span className="font-bold text-blue-600">{ventasCount}</span> de <span className="font-bold text-blue-600">{totalVentas}</span> ventas
              {totalVentas > 0 && (
                <span className="text-gray-500"> • Página {currentPage}</span>
              )}
            </p>
            {(fechaInicio || fechaFin) && (
              <p className="text-gray-500 text-xs">
                Filtrado por fechas • Límite: {INFINITE_SCROLL_CONFIG.ITEMS_PER_PAGE} por página
              </p>
            )}
            {!fechaInicio && !fechaFin && totalVentas > 0 && (
              <p className="text-gray-500 text-xs">
                Todas las ventas • Límite: {INFINITE_SCROLL_CONFIG.ITEMS_PER_PAGE} por página
              </p>
            )}
          </div>
        </div>
        {hasMore && (
          <div className="flex items-center gap-2 text-sm text-gray-500">
            <span className="animate-pulse">⏳</span>
            <span>Más resultados disponibles</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default ResultsIndicator;
